import { ErrorBoundary } from "@sentry/react";
import React from "react";
import { ErrorMsg } from "../../components/AppMessages";
import { OnlineCeFilters } from "../../components/Filters/OnlineCeFilters";
import { IframeLayout } from "../../components/Layouts";
import { IframePageContent } from "../../components/PageContent";
import { OCE_DIGITAL_TREND_LOOKER_URL, ONLINE_CE_FILTERS } from "../../constants/onlinCePerformance";

// Same access as the rest of Online CE Performance (see dashboardRegistry.ts's own
// "oce_digital_trends" row, internal_view "online_ce_performance") - a straight Looker Studio
// embed, no page-specific filters of its own beyond the shared Online CE nav row
// (ONLINE_CE_FILTERS).
const OceDigitalTrend = () => {
  return (
    <IframeLayout hasFilter={true}>
      <ErrorBoundary fallback={<ErrorMsg />}>
        <IframePageContent
          frameId="oce_digital_trend"
          filter={<OnlineCeFilters filterBtns={ONLINE_CE_FILTERS} />}
          iframeUrl={OCE_DIGITAL_TREND_LOOKER_URL}
        />
      </ErrorBoundary>
    </IframeLayout>
  );
};

export default OceDigitalTrend;
